import { ROUTE_PATHS } from '../../core/constants/app-routes.constant';

export interface MenuItem {
  icon: string;
  label: string;
  link: string;
}

export let MenuItems = {
    DASHBOARD: {
        icon: "",
        label: "Dashboard",
        link: ROUTE_PATHS.dashboard(),
  },

    CONTEST: {
      icon: "",
      label: "Contest",
      link: ROUTE_PATHS.contest.root(),
    },
    QUESTION: {
      icon: "",
      label: "Question",
      link: ROUTE_PATHS.question.root(),
    },
    USER: {
      icon: "",
      label: "User",
      link: ROUTE_PATHS.user.root(),
    }
};